import React from 'react';
import { Box, Stack } from '@mui/material';
import { CategoryOutlined } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import {
  CategoryEdit,
  PriorityEdit,
  UrgencyEdit
} from '../fields';

interface CategoryClassificationSectionProps {
  isEditMode?: boolean;
}

/**
 * CategoryClassificationSection - Contains ticket classification fields
 * Includes category, priority, and urgency for proper ticket routing and handling
 */
export const CategoryClassificationSection: React.FC<CategoryClassificationSectionProps> = ({ 
  isEditMode = false 
}) => {
  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<CategoryOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Category & Classification"
      />
      
      <SectionPaper>
        <Stack direction="row" gap={2} sx={{ width: '100%' }}>
          <CategoryEdit disabled={isEditMode} />
          <PriorityEdit />
          <UrgencyEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default CategoryClassificationSection;
